import "slick-carousel";

export default class TapestrySlider {
    constructor() {
        this.init();
        this.addEvents();
        this.handleWindowResize();
    }

    init() {
        this.sliders = [
            { selector: '.tapestry-slider.bottom-to-top .jet-listing-grid__items' },
            { selector: '.tapestry-slider.top-to-bottom .jet-listing-grid__items' }
        ];
    }

    addEvents() {
        this.initSlickCarousel();
    }

    initSlickCarousel() {
        const commonSettings = {
            vertical: true,
            arrows: false,
            infinite: true,
        };

        this.sliders.forEach(slider => {
            if($(slider.selector).length > 0) {
                this.initSlider(slider.selector, {...commonSettings, ...slider.options});
            }
        });
    }

    initSlider(selector, options) {
        let currentTranslateY = 0;
        let isHovered = false;
        let animationInterval;
        let transformValue = 'translate3d(0px, 0px, 0px)';

        try {
            $(selector).slick(options);

            const slider = $(selector);
            const slickTrack = slider.find('.slick-track');

            function startAnimation() {
                if (!isHovered) {
                    currentTranslateY -= 1;
                    transformValue = `translate3d(0px, ${currentTranslateY}px, 0px)`;

                    slickTrack.css('transform', transformValue);

                    if (Math.abs(currentTranslateY) >= slickTrack.height()) {
                        currentTranslateY = 0;
                    }
                }
            }

            slider.on('mouseenter', function() {
                isHovered = true;
                clearInterval(animationInterval);
            });

            slider.on('mouseleave', function() {
                isHovered = false;
                animationInterval = setInterval(startAnimation, 16);
            });

            animationInterval = setInterval(startAnimation, 16);

        } catch (err) {
            console.warn(err);
        }
    }

    handleWindowResize() {
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.reinitSlickCarousel();
            }, 200);
        });
    }

    reinitSlickCarousel() {
        this.sliders.forEach(slider => {
            const $slider = $(slider.selector);
            if (typeof $slider.slick === 'function') {
                $slider.slick('refresh');
            }
        });
    }
}